import { getHomeFaqStrings } from "../i18n/homeFaqStrings";
import { useFaqJsonLd } from "../hooks/useFaqJsonLd";

// Custom rendering rather than the shared <FaqSection> (see ToolExplainer.tsx) because that
// component hardcodes an English "Frequently Asked Questions" heading regardless of locale — the
// home page needs a localized one. Still uses the same useFaqJsonLd hook so the visible text and the
// FAQPage JSON-LD can never disagree. id "home" must match the id baked into web/index.html's
// build-time SEO snapshot (see vite.config.ts) so the effect updates that script tag in place
// instead of creating a duplicate.
export function HomeFaq({ lang }: { lang: string }) {
  const faq = getHomeFaqStrings(lang);
  useFaqJsonLd("home", faq.items);

  return (
    <section className="home-faq" aria-labelledby="home-faq-title">
      <h2 id="home-faq-title" className="home-section-title">{faq.title}</h2>
      {faq.items.map((item) => (
        <div className="home-faq__item" key={item.question}>
          <h3>{item.question}</h3>
          <p>{item.answer}</p>
        </div>
      ))}
    </section>
  );
}
